<template>
  <VDropdown
    :id="`popover-${name}`"
    ref="dropdownElement"
    class="popover-container"
    :class="containerClass"
    popper-class="reset-dropdown"
    strategy="fixed"
    auto-size="min"
    placement="bottom"
    distance="0"
    @update:shown="shown = $event"
    @show="
      () => {
        addScrollListener();
      }
    "
    @hide="
      () => {
        removeScrollListener();
      }
    "
  >
    <slot
      :id="`popover-${name}-button`"
      class="popover-button"
      :open="shown"
    ></slot>
    <template #popper>
      <div
        :class="['dropdown-menu !relative !top-1', attrClass]"
        :style="attrStyle"
      >
        <slot name="panel"></slot>
      </div>
    </template>
  </VDropdown>
</template>

<script lang="ts">
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { Dropdown as VDropdown } from 'floating-vue';

import 'floating-vue/dist/style.css';

export default {
  inheritAttrs: false
};
</script>

<script setup lang="ts">
const { class: attrClass, style: attrStyle } = useAttrs();

const props = defineProps({
  containerClass: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    required: true
  },
  closeOnScroll: {
    type: Boolean,
    default: () => false
  }
});

const dropdownElement = ref<{
  show: () => void;
  hide: () => void;
  shown?: boolean;
} | null>(null);

const shown = ref(false);

function close() {
  console.log('close', dropdownElement, dropdownElement.value);
  if (dropdownElement.value) {
    dropdownElement.value.hide();
  }
}

function addScrollListener() {
  if (!props.closeOnScroll) {
    return;
  }
  window.addEventListener('scroll', close);
}

function removeScrollListener() {
  if (!props.closeOnScroll) {
    return;
  }
  window.removeEventListener('scroll', close);
}

defineExpose({
  close
});
</script>

<style lang="scss">
.popover-container .popover-button * {
  pointer-events: none;
}
</style>
